/** @format */

import { FC } from "react";
import { useTranslation, Trans } from "react-i18next";
import { Markup } from "interweave";
import { useLocale } from "../../i18n/hooks";
import termsConditions from "./termsConditions/termsConditions.json";
import DeleteUser from "./deleteUser/DeleteUser";

const Account: FC = () => {
  const { t: _ } = useTranslation();
  const locale = useLocale();

  var readable = new Date(termsConditions["published-date"]);

  var month = readable.getUTCMonth() + 1;
  var day = readable.getUTCDate();
  var year = readable.getUTCFullYear();

  return (
    <>
      <h3>{_("My Account")}</h3>
      <h4>{_("Terms and Conditions")}</h4>
      <div className="terms-conditions">
        <Markup
          tagName="div"
          content={termsConditions["terms-conditions"][locale]}
        />
      </div>
      <Trans
        i18nKey="agreed date"
        components={{ p: <p />, small: <small />, em: <em />, br: <br /> }}
        values={{ date: `${day}/${month < 10 ? "0" + month : month}/${year}` }}
      />
      <DeleteUser />
    </>
  );
};

export default Account;
